"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrder = void 0;
const common_1 = require("../../common");
const models_1 = require("../../hr/models");
const models_2 = require("../../partners/models");
const models_3 = require("../../products/models");
const models_4 = require("../../setup/models");
const enums_1 = require("../enums");
class WorkOrder extends common_1.MongoDocument {
}
exports.WorkOrder = WorkOrder;
//# sourceMappingURL=work-order.model.js.map